const r = (e) => `Bearer ${e}`, a = (e) => e.replace("Bearer ", "");
export {
  r as bearerValue,
  a as trimBearer
};
